import { BoxTree } from "./box-tree/box-tree";
import { BoxTreeBranch } from "./box-tree/box-tree-branch";
import { BoxTreeClosest } from "./box-tree/box-tree-closest";
import { BoxTreeLeaf } from "./box-tree/box-tree-leaf";
import { BoxTreeNode } from "./box-tree/box-tree-node";
import { math } from "./math";

export class OctTree<Item,Data=never> extends BoxTree<Item,math.Box3,Data>{
	public override newBox(){
		return new math.Box3();
	}

	public override newVec(){
		return new math.Vec3();
	}
}

export namespace OctTree{
	export type Node<Item,Data=never>=BoxTreeNode<Item,math.Box3,Data>;
	export const Node=BoxTreeNode;
	export type Branch<Item,Data=never>=BoxTreeBranch<Item,math.Box3,Data>;
	export const Branch=BoxTreeBranch;
	export type Leaf<Item,Data=never>=BoxTreeLeaf<Item,math.Box3,Data>;
	export const Leaf=BoxTreeLeaf;
	export type Closest<Item,Data>=BoxTreeClosest<Item,math.Box3,Data>;
}
